import { Component, Inject, Input, OnInit } from '@angular/core';
import { ActionWillBeEffectedViewModel, SystemReplacementWillEffectFutureActionsWarningViewModel } from '../../../../../app/modules/action/action-models';
import { ActionService } from '../../../../../app/modules/action/action.service.service';
import { ManageEquipmentService } from '../../../../../app/modules/manage-equipment/manage-equipment.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-confirm-action-back-in',
  templateUrl: './confirm-action-back-in.component.html',
  styleUrls: ['./confirm-action-back-in.component.scss']
})
export class ConfirmActionBackInComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ConfirmActionBackInComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _manageEquipmentService: ManageEquipmentService, private _actionService: ActionService,) { }

    
EquipmentId:number;
SMU:number;
ActionDate:Date;
getFutureInspectionForSelectedEquipment :SystemReplacementWillEffectFutureActionsWarningViewModel;
FutureInspection:  ActionWillBeEffectedViewModel[];
oldSystemDataSource =  new MatTableDataSource();
displayedColumns: string[] = [ 'ActionDate', 'ActionTypeName', 'OldActualLife' ];
  ngOnInit() {

    this.EquipmentId = this._data.EquipmentId;
    this.SMU = this._data.SMU;
    this.ActionDate = this._data.ActionDate;

  this.GetFutureInspectionForEquipment();
    
  }

GetFutureInspectionForEquipment(){
  this._actionService.getFutureInspectionForSelectedEquipment(this.EquipmentId,this.ActionDate,this.SMU).subscribe(res=>{
    this.getFutureInspectionForSelectedEquipment = res;
    this.FutureInspection = this.getFutureInspectionForSelectedEquipment.ActionsWillBeEffected;
    this.oldSystemDataSource.data = this.getFutureInspectionForSelectedEquipment.ActionsWillBeEffected;
  })
}
  

GoAhead(){

    this.dialogRef.close(true);
  }
  Cancel(){
    this.dialogRef.close(false);
  }
  // onNoClick(){
  //   this.dialogRef.close(0);
  // }
}
